import * as echarts from 'echarts/lib/echarts.js';

export const chartConfig = {
  symbols: {
    circle: 'M6 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6z',
    square: 'M0 0h12v12H0V0z',
    triangleUp: 'M6 0l6 10H0L6 0z',
    triangleDown: 'M6 9.9l6-10H0l6 10z',
    diamond: 'M6,0l6,6l-6,6L0,6L6,0z',
    donut: 'M6 12c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-9C4.3 3 3 4.3 3 6s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z',
    squareOutline: 'M12 12H0V0h12v12zM3 9h6V3H3v6z',
    triangleUpOutline: 'M12,10H0L6,0L12,10z M4,8.1h4L6,4.7L4,8.1z',
    diamondOutline: 'M6,11.9L0,6l6-6l6,6L6,11.9z M3.5,6l2.4,2.4L8.3,6L6,3.5C6,3.5,3.5,6,3.5,6z',
  },
};

export const defaultChartOptions = () => ({
  backgroundColor: '#fff',
  color: [
    '#4ec1ef',
    '#60e9b3',
    '#ffc65e',
    '#276c98',
    '#37ae8c',
    '#ed8a1a',
    '#002344',
  ],
  textStyle: {
    fontFamily: 'Source Sans Pro, sans-serif',
  },
  tooltip: {
    backgroundColor: 'rgb(45, 45, 45)',
    confine: true,
    extraCssText: `
      border-radius: 3px;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
    `,
    padding: 12,
  },
});

export const render = (container, chartOptions) => {
  const chart = echarts.init(container);
  if (chartOptions.forceRedraw) {
    chart.clear();
  }
  chart.setOption(chartOptions, true);
  return chart;
}
